module.exports = __webpack_public_path__ + "static/media/md-help.327916e3.svg";